import { v4 as uuid } from 'uuid';

import { NotificationTypes } from 'components/Notifications/Notification';
import { notificationActions } from './actions-const';

export function showNotification(notification) {
  return {
    type: notificationActions.SHOW_NOTIFICATION,
    notification: {
      id: notification.id || uuid(),
      type: notification.type || NotificationTypes.NOTIFICATION,
      message: notification.message,
    },
  };
}

export function clearNotification(notificationId) {
  return (dispatch) => {
    dispatch({ type: notificationActions.CLEAR_NOTIFICATION, notificationId });
  };
}
